/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScoreboardEventBreakdownDates = {
    properties: {
        date: {
    type: 'string',
},
        eventMetricId: {
    type: 'number',
    isRequired: true,
},
        eventMetricName: {
    type: 'string',
    isRequired: true,
},
        groupTotal: {
    type: 'number',
    isRequired: true,
},
        leaderEmployee: {
    type: 'string',
    isRequired: true,
},
    },
};